<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind(shopSoort.Catalogus)">
  <app-catalog-parts-boxed-layout *ngSwitchDefault [ctx]="ctx"></app-catalog-parts-boxed-layout>
  <app-catalog-parts-scroll-layout *ngSwitchCase="1" [ctx]="ctx"></app-catalog-parts-scroll-layout>
</ng-container>
